import {
    saveWoocommerceIntegration,
    getWoocommerceState,
    getWoocommerceData,
} from './woocommerce.state';
import { integrationHookFactory } from '../integrations.hooks';

export const useWoocommerce = integrationHookFactory({
    saveAction: saveWoocommerceIntegration,
    loadAction: getWoocommerceData,
    stateSelector: getWoocommerceState,
});
